import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { deleteEntityIntegration } from "./api";

export function useDeleteEntityIntegration(entityId, options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEntityIntegration,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`${variables.provider}-${entityId}`],
      });
      toast.success("Integration disconnected successfully");
      options.onSuccess?.(data, variables);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to delete integration");
      options.onError?.(error);
    },
  });
}
